import { createAsyncThunk } from "@reduxjs/toolkit";
import { rdsEvent_Dto, rdsEvent_ResponseDto, rdsEventAll_RequestDto, rdsEventAll_ResponseDto } from "../../interfaces/dtos/rdsEvent";
import { rdsEventGet } from "../../utils/rds";
import { apiUrls } from "../../components/shared/apiUrls";
import { jsonToQueryString } from "../../utils/http";
import { AppThunk, RootState } from "../store";
import { toUKDate } from "../../utils/commonUtils";

export const loadRdsEvents = createAsyncThunk(
    'rds/loadRdsEvents',
    async (meetingId: number, { getState }) => {

        const request: rdsEventAll_RequestDto = {
            meetingId
        };

        const response = await rdsEventGet<rdsEventAll_ResponseDto>(
            `${apiUrls.rdsEvents.getAll}?${jsonToQueryString(request)}`
        );

        const { rds } = getState() as RootState;
        const otherEvents = rds.rdsEvents.filter((e) => e.meetingId !== meetingId);

        return [
            ...otherEvents, 
            ...response.data.map((e) => mapEvent(e))
        ];
    }
);

export const loadRdsEventsMultiple = (
    meetingIds: number[]
): AppThunk =>
    async (dispatch) => {

        meetingIds.forEach((m) => {
            dispatch(loadRdsEvents(m))
        })

    };

export const loadRdsEvent = createAsyncThunk(
    'rds/loadRdsEvent',
    async (eventId: number, { getState }) => {

        const response = await rdsEventGet<rdsEvent_ResponseDto>(
            apiUrls.rdsEvents.get(eventId)
        );

        const { rds } = getState() as RootState;
        const otherEvents = rds.rdsEvents.filter((e) => e.id !== eventId);

        return [...otherEvents, mapEvent(response.data)];
    }
);

const mapEvent = (event: rdsEvent_Dto) => {
    const dateTime = toUKDate(event.dateTime)!;
    return {
        ...event,
        dateTime
    }
}
